if (!customElements.get('sticky-anchor-bar')) {
    class StickyAnchorBar extends HTMLElement {
        constructor() {
            super()

            // 锚标记ID
            this.anchorSections = []
            this.isMobileMedia = window.matchMedia('(max-width: 767px)')

            this.onAnchorItemClickListener = this.onAnchorItemClick.bind(this)
            this.onWindowScrolledListener = this.throttle(this.onWindowScrolled.bind(this));
            this.onAnchorListScrolledListener = this.throttle(this.onAnchorListScrolled.bind(this));


            this.anchorResizeObserver = new ResizeObserver(() => {
                this.onAnchorListScrolledListener()
            })

            this.initSectionIdMarker()

            this.querySelector('.nav-left').addEventListener('click', () => {
                this.anchorList.scrollTo({ left: this.anchorList.scrollLeft - 100, behavior: 'smooth' });
            })
            this.querySelector('.nav-right').addEventListener('click', () => {
                this.anchorList.scrollTo({ left: this.anchorList.scrollLeft + 100, behavior: 'smooth' });
            })
        }

        get header() {
            return document.querySelector('header.header')
        }

        get anchorIds() {
            const ids = []
            this.anchorItems.forEach(item => {
            if (item.dataset.anchorId) {
                ids.push(item.dataset.anchorId)
            }
            })
            return ids
        }
        
        get anchorList() {
            return this.querySelector('.anchor-list')
        }

        get anchorItems() {
            return Array.from(this.querySelectorAll('.anchor-list .anchor-item'))
        }

        get footer() {
            return document.querySelector('footer')
        }

        throttle(func, delay) {
            let lastCallTime = 0;
            let timeoutId = null;
            
            return function(...args) {
                const now = Date.now();
                const remainingTime = delay - (now - lastCallTime);
                
                clearTimeout(timeoutId);
                
                if (remainingTime <= 0) {
                // 如果距离上次执行已经超过delay时间，立即执行
                lastCallTime = now;
                func.apply(this, args);
                } else {
                // 否则设置定时器，在剩余时间后执行
                timeoutId = setTimeout(() => {
                    lastCallTime = Date.now();
                    func.apply(this, args);
                }, remainingTime);
                }
            };
        }

        connectedCallback() {
            this.onAnchorListScrolled()
            this.anchorItems.forEach(item => {
                if (item.dataset.anchorId) {
                    item.addEventListener('click', this.onAnchorItemClickListener)
                }
            })

            window.addEventListener('scroll', this.onWindowScrolledListener)
            this.anchorList.addEventListener('scroll', this.onAnchorListScrolledListener)

            this.anchorResizeObserver.observe(this.anchorList)
        }

        disconnectedCallback() {
            this.anchorItems.forEach(item => {
                item.removeEventListener('click', this.onAnchorItemClickListener)
            })
            window.removeEventListener('scroll', this.onWindowScrolledListener)
            this.anchorList.removeEventListener('scroll', this.onAnchorListScrolledListener)

            this.anchorResizeObserver.disconnect()
        }

        // 将shopify-section打上锚标记
        initSectionIdMarker() {
            if (this.anchorIds.length === 0) {
                return
            }
            const anchorSections = []
            for (const anchorId of this.anchorIds) {
                const sectionAnchor = document.querySelector(`[anchor-id="${anchorId}"]`)
                if (sectionAnchor) {
                    let section
                    if (sectionAnchor.classList.contains('sticky-anchor')) {
                        section = sectionAnchor?.closest('.shopify-section')?.nextElementSibling
                    } else {
                        section = sectionAnchor?.closest('.shopify-section')
                    }
                    if (section) {
                        section.setAttribute('section-anchor-id', anchorId)
                        anchorSections.push(section)
                    }
                }
            }
            this.anchorSections = anchorSections
        }

        onAnchorItemClick(e) {
            const anchor = e.target.dataset.anchorId
            const scrollView = this.anchorSections.find(item => item.getAttribute('section-anchor-id') == anchor)
            if (scrollView) {
                const offset = this.getBoundingClientRect().height
                let elementPosition = scrollView.getBoundingClientRect().top;
                let offsetPosition = elementPosition + window.scrollY - offset;
                window.scrollTo({top: offsetPosition, behavior: "smooth"})
            }
        }

        onWindowScrolled() {
            this.onScrolledForAuto()
            this.onScrolledToFindMatchSection()
        }

        /**
         * 滚动网页时，找到anchor item对应的模块，如果找到就将anchor item激活
         */
        onScrolledToFindMatchSection() {
            let barHeight = this.getBoundingClientRect().height
            
            const visibleSection = this.anchorSections.find(section => {
                const rect = section.getBoundingClientRect();
                return rect.top - barHeight <= 20 && rect.bottom - barHeight >= 80;
            });
            this.anchorItems.forEach(item => item.classList.remove('active'));
            const sectionAnchorId = visibleSection?.getAttribute('section-anchor-id');
            if (sectionAnchorId) {
                this.anchorItems.find(item => item.dataset.anchorId === sectionAnchorId)?.classList.add('active');
            }
        }

        onScrolledForAuto() {
            const rect = this.getBoundingClientRect()
            const top = rect.top
            const bottom = rect.bottom
            const hideHeader = top <= 20
            
            if (hideHeader) {
                this.header.style.visibility = 'hidden'
                if (!this.classList.contains('pin')) {
                    this.classList.add('pin')
                }
                const positionTop = Math.max(0, this.header.getBoundingClientRect().bottom) - 2
                this.style.setProperty('--sticky-bar-top', `0px`)
            } else {
                this.header.style.visibility = 'visible'
                this.classList.remove('pin')
            }
            
        }

        onAnchorListScrolled() {
            if (this.anchorList.scrollWidth <= this.anchorList.clientWidth) {
                this.setAttribute('anchor-scroll-pos', 'none')
            } else if (this.anchorList.scrollLeft <= 0) {
                this.setAttribute('anchor-scroll-pos', 'left')
            } else if(this.anchorList.scrollLeft + this.anchorList.clientWidth >= this.anchorList.scrollWidth) {
                this.setAttribute('anchor-scroll-pos', 'right')
            } else {
                this.setAttribute('anchor-scroll-pos', 'center')
            }
        }
    }
    customElements.define('sticky-anchor-bar', StickyAnchorBar)
}